//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Type of workflow trigger */
export const BenevolenceWorkflowTriggerType = {
    /** Request Started */
    RequestStarted: 0,

    /** Status Changed */
    StatusChanged: 1,

    /** Caseworker Assigned */
    CaseworkerAssigned: 2,

    /** Manual */
    Manual: 3
} as const;

/** Type of workflow trigger */
export const BenevolenceWorkflowTriggerTypeDescription: Record<number, string> = {
    0: "Request Started",

    1: "Status Changed",

    2: "Caseworker Assigned",

    3: "Manual"
};

/** Type of workflow trigger */
export type BenevolenceWorkflowTriggerType = typeof BenevolenceWorkflowTriggerType[keyof typeof BenevolenceWorkflowTriggerType];
